import { render, staticRenderFns } from "./addauser.vue?vue&type=template&id=cff043cc&scoped=true&"
import script from "./addauser.vue?vue&type=script&lang=js&"
export * from "./addauser.vue?vue&type=script&lang=js&"
import style0 from "./addauser.vue?vue&type=style&index=0&id=cff043cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff043cc",
  null
  
)

export default component.exports